(()=>{
  const setupCtas=()=>{
    const home=document.querySelector('.ep-home');
    if(home){
      [...home.querySelectorAll('a.ep-btn')].forEach(link=>{
        const text=link.textContent.trim();
        if(text.includes('Ver todo lo que incluye')) link.href='/products/kit-vende-mas-emprendia-pro#que-incluye';
        if(text.includes('Conocé el Kit Vendé Más')) link.href='/products/kit-vende-mas-emprendia-pro';
        if(text.includes('Conocer Vendé Más')) link.href='/products/kit-vende-mas-emprendia-pro';
        if(text.includes('Explorar recursos')) link.href='/collections/recursos-para-emprendedores';
      });
    }

    const vm=document.querySelector('.vm-page');
    if(vm){
      const includesSection=vm.querySelector('.vm-grid')?.closest('.vm-section');
      if(includesSection) includesSection.id='que-incluye';
      const faqSection=vm.querySelector('.vm-faq')?.closest('.vm-section');
      if(faqSection) faqSection.id='preguntas';
      const finalSection=vm.querySelector('.vm-final');
      if(finalSection) finalSection.id='comprar';

      const forms=[...vm.querySelectorAll('form.vm-form')];
      forms.forEach((form,index)=>{
        const idInput=form.querySelector('input[name="id"]');
        const button=form.querySelector('.vm-buy');
        if(!idInput||!button) return;
        if(!button.disabled){
          button.type='button';
          button.textContent=index===0?'Comprar ahora →':'Comprar el Kit →';
          button.addEventListener('click',()=>{
            window.location.href=`/cart/${idInput.value}:1?checkout`;
          });
        }
      });

      const heroForm=vm.querySelector('.vm-copy .vm-form');
      if(heroForm && !vm.querySelector('.vm-secondary-cta')){
        const secondary=document.createElement('a');
        secondary.className='vm-secondary-cta';
        secondary.href='#que-incluye';
        secondary.textContent='Ver qué incluye';
        heroForm.insertAdjacentElement('afterend',secondary);
      }

      if(!document.getElementById('ep-cta-routing-styles')){
        const style=document.createElement('style');
        style.id='ep-cta-routing-styles';
        style.textContent=`
          .vm-copy .vm-form{display:inline-block;width:min(100%,460px);vertical-align:top}
          .vm-secondary-cta{display:inline-flex;align-items:center;justify-content:center;margin-top:10px;width:min(100%,460px);padding:15px 22px;border:1px solid rgba(255,255,255,.28);border-radius:12px;color:#fff!important;text-decoration:none!important;font-weight:850;background:rgba(255,255,255,.06);backdrop-filter:blur(8px);transition:transform .2s ease,border-color .2s ease,background .2s ease}
          .vm-secondary-cta:hover{transform:translateY(-2px);border-color:rgba(255,255,255,.55);background:rgba(255,255,255,.11)}
          #que-incluye,#preguntas,#comprar{scroll-margin-top:96px}
        `;
        document.head.appendChild(style);
      }
    }
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setupCtas,{once:true});
  else setupCtas();

  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced)return;
  const root=document.querySelector('.ep-home,.vm-page');
  if(!root)return;
  const bar=document.createElement('div');bar.className='ep-scroll-progress';document.body.appendChild(bar);
  const glow=document.createElement('div');glow.className='ep-cursor-glow';document.body.appendChild(glow);
  window.addEventListener('pointermove',e=>{glow.style.left=e.clientX+'px';glow.style.top=e.clientY+'px'},{passive:true});
  const reveal=[...root.querySelectorAll('.ep-section,.ep-strip,.ep-cta,.vm-section,.vm-proof,.vm-final,.ep-heading,.vm-title')];
  reveal.forEach(el=>el.classList.add('ep-motion-reveal'));
  const staggers=[...root.querySelectorAll('.ep-card-grid,.ep-steps,.vm-grid,.vm-steps,.ep-strip-grid,.vm-proof .vm-wrap')];
  staggers.forEach(el=>el.classList.add('ep-motion-stagger'));
  const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ep-visible');io.unobserve(entry.target)}}),{threshold:.12,rootMargin:'0px 0px -7% 0px'});
  [...reveal,...staggers].forEach(el=>io.observe(el));
  const heroImg=root.querySelector('.ep-hero-media img,.vm-media img');
  const heroCopy=root.querySelector('.ep-hero-copy,.vm-copy');
  let raf=false;
  window.addEventListener('scroll',()=>{if(raf)return;raf=true;requestAnimationFrame(()=>{const y=window.scrollY;const doc=document.documentElement;const max=doc.scrollHeight-innerHeight;bar.style.width=(max>0?Math.min(100,y/max*100):0)+'%';if(y<900){if(heroCopy)heroCopy.style.transform=`translate3d(0,${y*.055}px,0)`;if(heroImg)heroImg.style.setProperty('--ep-parallax',`${y*-.025}px`)}raf=false})},{passive:true});
  const tilt=[...root.querySelectorAll('.ep-card,.vm-grid article')];
  tilt.forEach(card=>{card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.transform=`perspective(900px) rotateX(${y*-5}deg) rotateY(${x*7}deg) translateY(-4px)`});card.addEventListener('pointerleave',()=>card.style.transform='')});
  const magnets=[...root.querySelectorAll('.ep-btn,.vm-buy,.vm-secondary-cta')];
  magnets.forEach(btn=>{btn.addEventListener('pointermove',e=>{const r=btn.getBoundingClientRect(),x=e.clientX-r.left-r.width/2,y=e.clientY-r.top-r.height/2;btn.style.transform=`translate(${x*.08}px,${y*.12}px)`});btn.addEventListener('pointerleave',()=>btn.style.transform='')});
})();